<template>
  <el-drawer id="xzt_list" title="结算列表"
  :visible.sync="drawer"
  :direction="direction"
  :withHeader="false"
  :before-close="handleClose">
        <div class="header">
          <p v-if="user" style="font-weight: bold;">用户：{{user.username}}</p>
          <p>总金额:{{totalPrice}}</p>
          <p>平均可吃:{{average}}</p>
          <p>可吃总金额:{{settlement.total}}</p>
          <p>每注可吃:{{settlement.buy_price}}</p>
        </div>
        <div class="content">
            <el-table
          ref="tableArr"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :row-style="{height:'0'}"
          :cell-style="changeCellStyle"
        >
          <template v-for="item in items">
            <el-table-column
              v-if="item.id=='title'"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            >
              <template slot-scope="scope">
                <div :class="`title ${scope.row.color}`"><span class="num-title">{{scope.row.title}}</span>  <span class="sx-name" v-if="getSxName(scope.row)">{{getSxName(scope.row)}}</span></div>
              </template>
            </el-table-column>
            <el-table-column
            v-else
              :key="item.name"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            ></el-table-column>
          </template>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            class="operate"
            width="160"
            v-if="isshow"
          >
            <template scope="scope">
              <div>
                <el-button
                  @click="onHandle(scope.$index, scope.row)"
                  size="mini"
                  type="success"
                >编辑</el-button>
                 <el-button
                  @click="onDelete(scope.$index, scope.row)"
                  size="mini"
                  type="danger"
                >删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        </div>
    </el-drawer>
</template>
<script>
import { getNumberSxName } from "./num.js";
export default {
    data(){
        return {
            items: [
                { name: "序号", id: "index" },
                { name: "号码", id: "title" },
                { name: "需投注", id: "douyu" },
                { name: "总金额", id: "total" },
            ],
            tableData:[],
            drawer: false,
            direction: 'rtl',
            isshow:false,
            settlement:{
              total:0,
              buy_price:0,
            },
            user:null,
            totalPrice:0,
            average:0,
            currentYear: new Date().getFullYear(),
        }
    },
    methods: {
      changeCellStyle (value) {
      //列的label的名称
       if(value.rowIndex == this.tableData.length-1){
          return 'background:white;height:30px;padding:0;color:red;font-weight:bold;font-size:18px;'
        }else if (value.columnIndex === 2) {
          return 'color:black;background:orange;font-weight:bold;font-size:16px;height:30px;padding:0;' //修改的样式
        }else if(value.rowIndex === 21){
          return 'background:#ddd;height:30px;padding:0;'
        } else {
          return 'height:30px;padding:0;'
        }
        
      },
        getSxName(row) {
            if (!row || !row.title) return "";
            return row.sx_txt || getNumberSxName(row.title, this.currentYear);
        },
        show(value,total,average,user,currentYear) {
            this.drawer = true;
            this.user = user;
            this.totalPrice = total;
            this.average = average;
            if (currentYear) this.currentYear = currentYear;
            if (value !== undefined) {
                this.settlement = value;
                this.tableData = value.moneys.sort((b,a)=>{
                    return parseInt(a.total)-parseInt(b.total);
                });
                var dall = 0;
                this.tableData.forEach((item,index)=>{
                  item.index = index+1;
                  dall = dall+parseInt(item.douyu);
                })

                this.tableData.push({
                  index:"总计",
                  title:"",
                  douyu:dall,
                  total:this.totalPrice,
                })
                
                this.tableData.push({
                  index:"水",
                  title:"",
                  douyu:"",
                  total:parseInt(this.totalPrice*0.08),
                })

                console.log("table:",this.tableData);
            } else {
            }
        },
    }
}
</script>
<style lang="less" scope>
#xzt_list {
  font-size: 20px;
  color: black;
  /deep/.el-drawer{
      min-width: 500px;
      
  }
  .header {
        height: 40px;
        width: 100%;
        background-image: linear-gradient(to right, #0f6ad7, #00ced4);
        padding:0 30px;
        box-sizing: border-box;
        color:white;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        line-height: 40px;
        p{
          display: inline-block;
          margin-left:10px;
        }
        
    }

    
  
  .content{
    //   width: 1000px;
    //   margin: 0 auto;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100vh - 40px);
    /deep/.el-table .rowstyle {
        background: black;
      }
    .title{
      font-size: 20px;
      font-weight: bold;
      line-height: 18px;
      .num-title{
        display: inline-block;
      }
      .sx-name{
        display: inline-block;
        color: #303133;
        font-size: 12px;
        font-weight: normal;
      }
      &.red {
                color: rgb(245, 140, 140);
            }
            &.blue {
                color: rgb(118, 118, 242);
            }
            &.green {
                color: rgb(64, 209, 64);
            }
            
            }
    
  }
}
</style>